import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, HostListener, OnDestroy, AfterViewChecked } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RouterService } from 'src/app/services/router.service';
import { ResourceLoaderService } from 'src/app/services/resource-loader.service';


@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit,AfterViewInit, AfterViewChecked {
  @ViewChild('burgerMenu') burgerMenu!: ElementRef;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  menuToggle: boolean = true;
  activeMenu: string = 'nav';
  menuDisplay = 'none';

  userDetail: any;

  private lastScrollTop = 0;
  private scrollUpThreshold = 200;
  navlist: any = []

  deploymentEnv = environment?.deployment;


  isMenuOpened: boolean = false;
  screenSubscription!: Subscription;
  showScrollButton = false;

  private scrollHandler: (() => void) | null = null;
  constructor(private router: RouterService, private resourceLoader: ResourceLoaderService) {

  }

  ngOnInit(): void {

    if (localStorage.getItem('user_detail')) {
      this.userDetail = JSON.parse(localStorage.getItem('user_detail') || "{}")
    }
  }

  ngAfterViewInit(): void {
    this.loadResources();
  }

  ngAfterViewChecked() {
    this.checkScrollPosition();
  }



  checkScrollPosition() {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      const element = this.scrollContainer.nativeElement;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
      this.showScrollButton = !atBottom;
    }
  }


  onScroll(event: Event) {

    const element = event.target as HTMLElement;
    const scrollTop = element.scrollTop;

    if (scrollTop < this.lastScrollTop) {
      // Scrolling up
      if (element.scrollHeight - scrollTop - element.clientHeight > this.scrollUpThreshold) {
        this.showScrollButton = true;
      }
    } else {
      // Scrolling down
      if (element.scrollHeight - scrollTop === element.clientHeight) {
        this.showScrollButton = false;
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }

  ngOnDestroy() {
    if (this.scrollHandler) {
      this.scrollContainer.nativeElement.removeEventListener('scroll', this.scrollHandler);
    }
  }


  scrollToBottom() {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  }

  loadResources(): void {
    const scripts = [
      'assets/prismjs/prism.js',
      'assets/prismjs/components/prism-csharp.min.js',
      'assets/prismjs/components/prism-css.min.js',
      'assets/prismjs/plugins/line-numbers/prism-line-numbers.js',
      'assets/prismjs/plugins/line-highlight/prism-line-highlight.js',
      'assets/prismjs/plugins/command-line/prism-command-line.js',
      'assets/katex/katex.min.js',
      'assets/katex/contrib/auto-render.min.js',
      'assets/mermaid/mermaid.min.js',
      'assets/clipboard/clipboard.min.js'
    ];

    const styles = [
      'assets/prismjs/themes/prism-okaidia.css',
      'assets/prismjs/plugins/line-numbers/prism-line-numbers.css',
      'assets/prismjs/plugins/line-highlight/prism-line-highlight.css',
      'assets/prismjs/plugins/command-line/prism-command-line.css',
      'assets/katex/katex.min.css'
    ];

    scripts.forEach(script => this.resourceLoader.loadScript(script).catch(console.error));
    styles.forEach(style => this.resourceLoader.loadStyle(style).catch(console.error));
  }



  isPlayMode() {
    return this.router.isPlayMode();
  }

}